"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 30 10",
    width: props.size || props.width || "24px",
    id: "visa",
    height: props.size || props.height || "24px"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("linearGradient", {
    x1: "16.148%",
    y1: "34.401%",
    x2: "85.832%",
    y2: "66.349%",
    id: "visa__c"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#1434cb"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.475 6.71c-.017-1.344 1.198-2.094 2.113-2.54.94-.458 1.256-.751 1.253-1.16-.008-.627-.75-.903-1.446-.914-1.213-.019-1.918.328-2.479.59L14.48.64c.563-.26 1.604-.485 2.685-.495 2.535 0 4.194 1.251 4.203 3.192.01 2.463-3.407 2.6-3.383 3.7.008.334.326.69 1.024.78.346.047 1.3.082 2.38-.416l.425 1.978a6.471 6.471 0 01-2.26.415c-2.386 0-4.064-1.27-4.078-3.085m10.416 2.914a1.1 1.1 0 01-1.027-.684L21.242.29h2.533l.505 1.393h3.096L27.67.291h2.233l-1.949 9.333h-2.062m.355-2.521l.73-3.505h-2.002l1.272 3.505M12.403 9.624L10.406.291h2.414l1.996 9.333h-2.413m-3.572 0L6.318 3.272 5.3 8.673c-.12.603-.59.951-1.113.951H.079l-.057-.27c.843-.184 1.801-.48 2.382-.795.355-.193.457-.361.573-.82L4.903.291h2.552l3.912 9.333H8.83",
    id: "visa__a"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1 0 0 -1 0 10)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("mask", {
    id: "visa__b",
    fill: "#fff"
  }, /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#visa__a"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    mask: "url(#visa__b)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "url(#visa__c)",
    fillRule: "nonzero",
    d: "M0 18.244l29.44 10.842L36.139 10.9 6.698.057",
    transform: "translate(-3.107 -9.602)"
  }))));
};
var _default = exports["default"] = SvgComponent;